export default "__VITE_ASSET__CMeAjj_$__"